module.exports = __webpack_public_path__ + "img/like_yellow.85d326d4.svg";